// Settings configured here will be merged into the final config object.
import { HearkenStatus } from 'types/hearkenStatus'

export default {
  articleId: '256033792193',
  googleSheetKey: '1SZb7YB4XYhxzs75AbbydBoubnWJo0TBbaZJXhW-S8JM',
  embeds: {
    [HearkenStatus.VOTING]: [
      'https://modules.wearehearken.com/der-bund-tamedia/embed/5837.js'
    ],
    [HearkenStatus.COLLECTING]: [
      'https://modules.wearehearken.com/der-bund-tamedia/embed/5836.js'
    ],
    [HearkenStatus.PUBLISHING]: [],
    [HearkenStatus.INVESTIGATING]: []
  }
}
